module.exports = new __parcel__URL__("tubular-bells.2c3595bd.jpg").toString();